import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import { CALL_API } from "common/API";
import { NON_EMPTY_REGEX } from "common/Constants";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientid, getIsShowAgain } from "redux/selectors";
import styled from "styled-components";

import { RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { uniqBy } from "lodash";
import { saveIsShowAgain } from "redux/actions";
import { Cell } from "jspdf-autotable";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(utc);
dayjs.extend(timezone);

const ShiftMappingBox = styled.div`
  background: #f3f6ff;
  border-radius: 10px;
  padding: 16px;
`;

const ShiftRow = styled(Row)`
  align-items: center;
  margin-bottom: 12px;
`;

const ShiftLabel = styled.div`
  font-weight: 500;
  color: #333;
`;

const ShiftTiming = styled.span`
  // margin-left: 12px;
  color: #999;
  font-size: 12px;
`;

const StyledModal = styled(Modal)`
  .box {
    background: #e3e8fc;
    border-radius: 5px;
  }
  .box-gray {
    background: #fafafa;
    border-radius: 5px;
  }
`;

const ChangeShift = ({
  open,
  setOpen,
  selectedCell,
  shiftList,
  getAssignedShiftList,
  selectedRowIds,
  handleCancel,
  selectedCells,
  isMonthly,
  dataSource = [],
  currentDate,
  currentTime,
  userTimeZone,
}) => {
  console.log("selectedCells-->", selectedCells);
  console.log("selectedRowIds-->", selectedRowIds);

  const ClientId = useSelector(getClientid);
  const getShowAgain = useSelector(getIsShowAgain);
  const [form] = Form.useForm();
  const containerRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [isShiftFound, setIsShiftFount] = useState(false);
  const [selectedShift, setSelectedShift] = useState([]);
  const [isDateCheckLoader, setIsDateCheckLoader] = useState(false);
  const dispatch = useDispatch();
  const findShift = shiftList?.find(
    (val) => val?.shift_id === form.getFieldValue("shifttype")
  );

  const restrictPastDate = (current, type) => {
    const fromDate = form.getFieldValue("fromdate");
    if (type === "todate") {
      return current && fromDate && current < moment(fromDate).startOf("day");
    }
    return current && current < moment().startOf("day");
  };

  const checkInBetweenDates = async () => {
    try {
      setIsDateCheckLoader(true);
      const payload = {
        clientId: ClientId,
        userIds: [selectedCell?.userid],
        from: dayjs(form.getFieldValue("fromdate")).format("YYYY-MM-DD"),
        to: dayjs(form.getFieldValue("todate")).format("YYYY-MM-DD"),

        shiftMap: [
          {
            fromShift: selectedCell?.shift_id,
            toShift: {
              shift_id: form.getFieldValue("shifttype"),
              shifttitle: findShift?.shifttitle,
              shiftcode: findShift?.shiftcode,
              color: findShift?.color,
            },
          },
        ],
      };
      const { hasChangeableShifts } = await CALL_API(
        `check-changed-shift`,
        "post",
        payload
      );
      if (hasChangeableShifts === true || hasChangeableShifts === false) {
        setIsShiftFount(hasChangeableShifts);
      }
    } catch (error) {
      console.log("[onFinish] Error:", error);
    } finally {
      setIsDateCheckLoader(false);
    }
  };
  const selectedData =
    dataSource
      ?.filter((item) => selectedRowIds?.includes(item?.userid))
      ?.map(
        (item) => item?.[`${dayjs().tz(userTimeZone).format("YYYY-MM-DD")}_id`]
      ) || [];

  const seelectedMappings =
    form.getFieldValue("shiftMappings")?.map((item) => item?.oldShiftId) || [];
  const selectedshift =
    shiftList
      ?.filter(
        (val) =>
          selectedData?.includes(val?.shift_id) &&
          seelectedMappings?.includes(val?.shift_id)
      )
      ?.map((item) => dayjs(item.starts).format("HH:mm:ss")) || [];

  const isValid = !selectedshift.every((time) => time > currentTime);

  const unevenShifts =
    selectedCells
      ?.filter(
        (Cell) => Cell?.colKey === dayjs().tz(userTimeZone).format("YYYY-MM-DD")
      )
      ?.map((item) => item?.shiftid) || [];
  const unevenSelectedshift =
    shiftList
      ?.filter((val) => unevenShifts?.includes(val?.shift_id))
      ?.map((item) => dayjs(item.starts).format("HH:mm:ss")) || [];
  const isUnevenValid = !unevenSelectedshift.every(
    (time) => time > currentTime
  );

  const shift = shiftList?.find(
    (val) => val?.shift_id === selectedCell?.shiftId
  );

  console.log(
    "timeCheck-->",
    dayjs(form.getFieldValue("fromdate")).format("YYYY-MM-DD"),
    dayjs(currentDate).tz(userTimeZone).format("YYYY-MM-DD"),
    dayjs(shift?.starts)?.format("HH:mm:ss"),
    currentTime
  );

  const isShiftTimeValid =
    dayjs(form.getFieldValue("fromdate")).format("YYYY-MM-DD") ===
      dayjs(currentDate).tz(userTimeZone).format("YYYY-MM-DD") &&
    dayjs(shift?.starts)?.format("HH:mm:ss") < currentTime;
  const isSelectedShiftValid =
    dayjs(form.getFieldValue("fromdate")).format("YYYY-MM-DD") ===
      dayjs(currentDate).tz(userTimeZone).format("YYYY-MM-DD") &&
    currentTime >= dayjs(findShift?.starts)?.format("HH:mm:ss");

  const onFinish = async (values) => {
    const findShift = shiftList?.find(
      (val) => val?.shift_id === form.getFieldValue("shifttype")
    );
    try {
      setLoader(true);
      if (selectedRowIds?.length > 0) {
        const shiftmap = values?.shiftMappings?.map((item) => {
          const toShiftObj = shiftList?.find(
            (val) => val?.shift_id === item?.selectedShiftId
          );

          return {
            fromShift: item?.oldShiftId,
            toShift: {
              shift_id: toShiftObj?.shift_id,
              shifttitle: toShiftObj?.shifttitle,
              shiftcode: toShiftObj?.shiftcode,
              color: toShiftObj?.color,
            },
          };
        });

        const payload = {
          userIds: selectedRowIds,
          from: dayjs(values.fromdate).format("YYYY-MM-DD"),
          to: dayjs(values.todate).format("YYYY-MM-DD"),
          shiftMap: shiftmap,
          currentTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        const response = await CALL_API(
          `shift/bulk-change/${ClientId}`,
          "post",
          payload
        );
        if (response?.message === "Bulk shift change completed") {
          getAssignedShiftList();
          message?.success("shift has been changed successfully");
          form.resetFields();
          setIsShiftFount(false);
          setSelectedShift([]);
        }
      } else {
        const payload = {
          userIds:
            selectedCells?.length > 0
              ? []
              : selectedRowIds?.length
              ? selectedRowIds
              : [selectedCell?.userid],
          from: dayjs(values.fromdate).format("YYYY-MM-DD"),
          to: dayjs(values.todate).format("YYYY-MM-DD"),
          replaceExisting:
            values?.replaceall === true || values?.replaceall === false
              ? values?.replaceall
              : true,
          newShift: {
            shifttitle: findShift?.shifttitle,
            shift_id: values.shifttype,
            color: findShift?.color,
            shiftcode: findShift?.shiftcode,
          },
          userDateArray:
            selectedCells?.length > 0
              ? selectedCells?.map((item) => {
                  return { userid: item?.userid, colKey: item?.colKey };
                })
              : [],
          clickedShiftId: selectedCell?.shiftId,
        };
        const response = await CALL_API(
          `change-assigned-shift/${ClientId}`,
          "patch",
          payload
        );
        if (
          response?.message === "Shift change process completed" ||
          response?.message === "Shift changes applied successfully."
        ) {
          getAssignedShiftList();
          message?.success("shift has been changed successfully");
          form.resetFields();
          setIsShiftFount(false);
          handleCancel();
          setSelectedShift([]);
        }
      }
    } catch (error) {
      console.log("[onFinish] Error:", error);
    } finally {
      dispatch(
        saveIsShowAgain({ changeShift: form?.getFieldValue("changeshift") })
      );
      handleCancel();
      setLoader(false);
      setOpen(false);
    }
  };

  const showChangeConfirm = (values) => {
    if (getShowAgain?.changeShift) {
      onFinish(values);
    } else {
      Modal.confirm({
        title: "Are you sure you want to Change this Shift?",
        content: (
          <Form
            form={form}
            name="isShowagain"
            layout="vertical"
            initialValues={{ assignshift: getShowAgain?.changeShift }}
          >
            <Form.Item name="changeshift" valuePropName="checked">
              <Checkbox
                disabled={false}
                style={{ color: "#5d5f68", fontWeight: 500 }}
              >
                Don't show this again
              </Checkbox>
            </Form.Item>
          </Form>
        ),
        okText: "Yes, Change",
        cancelText: "No, Cancel",
        okButtonProps: {
          loading: loader,
        },
        onOk: async () => {
          onFinish(values);
        },
      });
    }
  };

  const handleWarning = () => {
    Modal.warning({
      title: "Shift change not allowed",
      content:
        "You cannot change the shift after check-in or once the shift time has passed.",
      okText: "OK",
    });
  };

  // useEffect(() => {
  //   if (selectedRowIds?.length > 0) {
  //     form.setFieldValue("fromdate", moment(currentDate.format("DD-MM-YYYY")));
  //     form.setFieldValue(
  //       "todate",
  //       isMonthly
  //         ? moment(currentDate).endOf("month")
  //         : moment(currentDate).endOf("week")
  //     );
  //     checkInBetweenDates();
  //     console.log(form.getFieldValue("fromdate"), "fromdate");
  //   } else if (selectedCell) {
  //     form.setFieldValue("fromdate", moment(selectedCell.date, "YYYY-MM-DD"));
  //     form.setFieldValue("todate", moment(selectedCell.date, "YYYY-MM-DD"));
  //   }
  // }, [
  //   selectedRowIds,
  //   isMonthly,
  //   form.getFieldValue("selectedShift"),
  //   selectedCell,
  //   currentDate,
  // ]);

  useEffect(() => {
    const selectedData =
      dataSource
        ?.filter((item) => selectedRowIds?.includes(item?.userid))
        ?.map(
          (item) =>
            item?.[`${dayjs().tz(userTimeZone).format("YYYY-MM-DD")}_id`]
        ) || [];

    const selectedshift =
      shiftList
        ?.filter(
          (val) =>
            selectedData?.includes(val?.shift_id) &&
            dayjs(val.starts).format("HH:mm:ss") > currentTime
        )
        ?.map((item) => item?.shift_id) || [];

    const selectedDatas =
      shiftList
        ?.filter(
          (val) =>
            selectedData?.includes(val?.shift_id) &&
            dayjs(val.starts).format("HH:mm:ss") < currentTime
        )
        ?.map((item) => item?.shift_id) || [];

    const today = moment().tz(userTimeZone).format("YYYY-MM-DD");
    const current = moment(currentDate);

    // if (selectedRowIds?.length > 0) {
    //   form.setFieldValue(
    //     "fromdate",
    //     current.isBefore(today)
    //       ? selectedshift?.length > 0
    //         ? today
    //         : selectedDatas?.length > 0 && selectedshift?.length === 0
    //         ? today.clone().add(1, "day")
    //         : today
    //       : current.clone().startOf("day")
    //   );

    //   form.setFieldValue(
    //     "todate",
    //     isMonthly
    //       ? current.clone().endOf("month")
    //       : current.clone().endOf("week")
    //   );

    //   checkInBetweenDates();
    // }
    if (selectedRowIds?.length > 0) {
      form.setFieldValue(
        "fromdate",
        isMonthly
          ? dayjs(currentDate).isBetween(
              dayjs().startOf("month"),
              dayjs().endOf("month"),
              "day",
              "[]"
            )
            ? dayjs()
            : dayjs(currentDate).startOf("month")
          : dayjs(currentDate).isBetween(
              dayjs().startOf("week"),
              dayjs().endOf("week"),
              "day",
              "[]"
            )
          ? dayjs()
          : dayjs(currentDate).startOf("week")
      );

      form.setFieldValue(
        "todate",
        isMonthly
          ? dayjs(currentDate).endOf("month")
          : dayjs(currentDate).endOf("week")
      );
      console.log("todate", dayjs(currentDate).endOf("month"));
      checkInBetweenDates();
    } else if (selectedCell) {
      form.setFieldValue("fromdate", dayjs(selectedCell.date, "YYYY-MM-DD"));
      form.setFieldValue("todate", dayjs(selectedCell.date, "YYYY-MM-DD"));
    }
  }, [
    selectedRowIds,
    isMonthly,
    form.getFieldValue("selectedShift"),
    selectedCell,
    currentDate,
  ]);

  // useEffect(() => {
  //   if (selectedCell) {
  //     form.setFieldsValue({
  //       fromdate: selectedCell?.date
  //         ? moment(selectedCell.date, "YYYY-MM-DD")
  //         : null,
  //       todate: selectedCell?.date
  //         ? moment(selectedCell.date, "YYYY-MM-DD")
  //         : null,
  //     });
  //   }
  // }, [selectedCell, form]);

  return (
    <StyledModal
      title={
        <div className="d-flex justify-content-between align-items-center">
          <div>Changing Shift</div>
          {selectedRowIds?.length > 0 && (
            <small className="mx-4" style={{ color: "#5d5f68" }}>
              Employee Chosen: <b>{selectedRowIds?.length}</b>
            </small>
          )}
        </div>
      }
      open={open}
      onCancel={() => {
        handleCancel();
        form?.resetFields();
        setIsShiftFount(false);
        setSelectedShift([]);
        setOpen(false);
      }}
      width={600}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            form.resetFields();
            handleCancel();
            setIsShiftFount(false);
            setSelectedShift([]);
            setOpen(false);
          }}
        >
          Cancel
        </Button>,
        <Button
          key="choose"
          type="primary"
          loading={loader}
          onClick={() => form.submit()}
        >
          Change
        </Button>,
      ]}
    >
      <Spin spinning={isDateCheckLoader}>
        <div style={{ minHeight: "300px" }}>
          <Form
            form={form}
            name="shiftform"
            layout="vertical"
            initialValues={{
              fromdate: selectedCell?.date
                ? dayjs(selectedCell.date, "YYYY-MM-DD")
                : null,
              todate: selectedCell?.date
                ? dayjs(selectedCell.date, "YYYY-MM-DD")
                : null,
            }}
            onFinish={(values) => {
              setOpen(false);
              if (
                selectedCells?.length === 0 &&
                selectedRowIds?.length === 0 &&
                (isShiftTimeValid || isSelectedShiftValid)
              ) {
                handleWarning();
                return;
              } else if (selectedCells?.length > 0 && isUnevenValid) {
                handleWarning();
                return;
              }
              // else if (selectedRowIds?.length > 0 && isValid) {
              //   handleWarning();
              // }
              else {
                showChangeConfirm(values);
              }
            }}
          >
            <Row gutter={20}>
              {selectedRowIds?.length > 0 && (
                <Col xs={24} sm={24} md={24} ref={containerRef}>
                  <Form.Item
                    className="mb-2 pb-0"
                    label="Select the shift you want to change"
                    name="selectedShift"
                    rules={[
                      {
                        required: true,
                        pattern: NON_EMPTY_REGEX,
                        message: "Shift type is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      mode="multiple"
                      optionFilterProp="label"
                      placeholder="Select Shift"
                      options={
                        shiftList
                          ?.filter((item) => item?.status === "active")
                          ?.map((val) => {
                            return {
                              label: val?.shifttitle,
                              value: val?.shift_id,
                            };
                          }) || []
                      }
                      fieldNames={{
                        label: "label",
                        value: "value",
                      }}
                      onChange={(values) => setSelectedShift(values)}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
              )}
              {selectedRowIds?.length === 0 && (
                <Col xs={24} sm={24} md={24} ref={containerRef}>
                  <>
                    {selectedCells?.length > 0 && (
                      <label className="mb-1">Selected Shift</label>
                    )}
                    <div className="box-gray p-2 mb-2">
                      {selectedCells?.length === 0 && (
                        <span style={{ color: "#5d5f68" }}>
                          Existing Shift{""}
                        </span>
                      )}
                      <span className={selectedCells?.length === 0 && "mx-3"}>
                        {selectedCells?.length > 0
                          ? uniqBy(selectedCells, "shifttitle")
                              .map((item) => item?.shifttitle)
                              .join(", ")
                          : selectedCell?.shiftTitle}
                      </span>
                    </div>
                  </>
                </Col>
              )}
              {selectedCells?.length === 0 && (
                <>
                  <Col
                    className="mt-2"
                    xs={24}
                    style={{ color: "#5d5f68", fontWeight: 500 }}
                  >
                    {selectedRowIds?.length > 0
                      ? "Specifiy the date range between which you want the shifts to be changed"
                      : "Specify the date range"}
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="From"
                      name="fromdate"
                      rules={[
                        {
                          required: selectedCells?.length === 0 ? true : false,
                          message: "From date is required",
                        },
                        {
                          validator: (_, value) =>
                            value && moment(value).isValid()
                              ? Promise.resolve()
                              : Promise.reject("Invalid date"),
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        className="w-100"
                        placeholder=""
                        disabledDate={(current) =>
                          restrictPastDate(current, "fromdate")
                        }
                        disabled={selectedRowIds?.length > 0 ? false : true}
                        getPopupContainer={() => containerRef.current}
                        onChange={(value) => {
                          const toDate = form.getFieldValue("todate");
                          if (
                            toDate &&
                            value &&
                            moment(value).isAfter(toDate)
                          ) {
                            form.setFieldsValue({ todate: value });
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={12}>
                    <Form.Item
                      label="To"
                      name="todate"
                      rules={[
                        {
                          required: selectedCells?.length === 0 ? true : false,
                          message: "Please select To Date",
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        style={{ width: "100%" }}
                        disabledDate={(current) =>
                          restrictPastDate(current, "fromdate")
                        }
                        onChange={checkInBetweenDates}
                      />
                    </Form.Item>
                  </Col>
                  {isShiftFound && selectedRowIds?.length === 0 && (
                    <Col xs={24} sm={24} md={24} ref={containerRef}>
                      <div className="box p-2 mb-2">
                        <Form.Item
                          className="pb-0 mb-0"
                          label="This employee has shifts assigned on some days within the selected date range"
                          name="replaceall"
                          rules={[
                            {
                              required:
                                selectedCells?.length === 0 ? true : false,
                              message: "Please Select Status",
                            },
                          ]}
                        >
                          <Radio.Group
                            placeholder="Radio.Group"
                            getPopupContainer={() => containerRef.current}
                          >
                            <Radio value={true}>Replace all the shifts</Radio>
                            <Radio value={false}>
                              Replace only "Existing Shift"
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </Col>
                  )}
                </>
              )}
              {selectedShift?.length > 0 && (
                <Col span={24}>
                  <Form.Item
                    label="Select new shift"
                    style={{ marginBottom: 8, fontSize: 13, color: "#666" }}
                  >
                    <ShiftMappingBox>
                      {selectedShift?.map((oldShiftId, index) => (
                        <ShiftRow gutter={16} key={index}>
                          <Col span={6}>
                            <ShiftLabel>
                              {
                                shiftList?.find(
                                  (val) => val?.shift_id === oldShiftId
                                )?.shifttitle
                              }
                            </ShiftLabel>
                          </Col>

                          <Col span={2} style={{ textAlign: "center" }}>
                            <RightOutlined style={{ color: "#999" }} />
                          </Col>

                          <Col span={10} ref={containerRef}>
                            <Form.Item
                              name={["shiftMappings", index, "selectedShiftId"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a shift",
                                },
                              ]}
                              noStyle
                            >
                              <Select
                                placeholder="Select Shift"
                                options={shiftList
                                  ?.filter((item) => item?.status === "active")
                                  ?.map((opt) => ({
                                    label: opt.shifttitle,
                                    value: opt.shift_id,
                                    starts: opt.starts,
                                    ends: opt.ends,
                                  }))}
                                getPopupContainer={() => containerRef.current}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={6}>
                            <ShiftTiming>
                              <Form.Item
                                shouldUpdate={(prev, cur) =>
                                  prev.shiftMappings?.[index]
                                    ?.selectedShiftId !==
                                  cur.shiftMappings?.[index]?.selectedShiftId
                                }
                                noStyle
                              >
                                {({ getFieldValue }) => {
                                  const selectedId = getFieldValue([
                                    "shiftMappings",
                                    index,
                                    "selectedShiftId",
                                  ]);
                                  const selectedShift = shiftList.find(
                                    (opt) => opt.shift_id === selectedId
                                  );
                                  return selectedShift
                                    ? `${dayjs(selectedShift.starts).format(
                                        "hh:mm A"
                                      )} - ${dayjs(selectedShift.ends).format(
                                        "hh:mm A"
                                      )}`
                                    : "";
                                }}
                              </Form.Item>
                            </ShiftTiming>
                          </Col>

                          {/* Hidden Field to store oldShiftId */}
                          <Form.Item
                            name={["shiftMappings", index, "oldShiftId"]}
                            initialValue={oldShiftId}
                            hidden
                          >
                            <input type="hidden" />
                          </Form.Item>
                        </ShiftRow>
                      ))}
                    </ShiftMappingBox>
                  </Form.Item>
                </Col>
              )}
              {selectedRowIds?.length === 0 && (
                <Col xs={24} sm={24} md={24} ref={containerRef}>
                  <Form.Item
                    className="mb-2 pb-0"
                    label="Select new shift"
                    name="shifttype"
                    rules={[
                      {
                        required: selectedRowIds?.length > 0 ? false : true,
                        pattern: NON_EMPTY_REGEX,
                        message: "Shift type is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="label"
                      placeholder="Select Shift"
                      options={
                        shiftList
                          ?.filter((item) => item?.status === "active")
                          ?.map((val) => {
                            return {
                              label: val?.shifttitle,
                              value: val?.shift_id,
                            };
                          }) || []
                      }
                      fieldNames={{
                        label: "label",
                        value: "value",
                      }}
                      // onChange={() => validateDateRange()}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
              )}
              {findShift && (
                <Col xs={24}>
                  <div className="box p-2">
                    <span style={{ color: "#5d5f68" }}>
                      Timing for this shift{""}
                    </span>
                    <span className="mx-3">
                      {moment(findShift?.starts).format("hh:mm A")} -{" "}
                      {moment(findShift?.ends).format("hh:mm A")}
                    </span>
                  </div>
                </Col>
              )}
              <Col xs={24} sm={24} md={24} ref={containerRef} className="mt-2">
                <Form.Item name="notifyemail" valuePropName="checked">
                  <Checkbox
                    disabled={false}
                    style={{ color: "#5d5f68", fontWeight: 500 }}
                  >
                    Notify these employees regarding shift change through Email
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Spin>
    </StyledModal>
  );
};

export default ChangeShift;
